import React, { useEffect, useRef, useState } from 'react';
import './careers.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import teamFace01 from '../../assets/careers/career-asset-01.png';
import teamFace02 from '../../assets/careers/career-asset-02.png';
import teamFace03 from '../../assets/careers/career-asset-03.png';
import teamFace04 from '../../assets/careers/career-asset-04.png';
import teamFace05 from '../../assets/careers/career-asset-05.png';
import teamFace06 from '../../assets/careers/career-asset-06.png';
import teamFace07 from '../../assets/careers/career-asset-07.png';
import teamFace08 from '../../assets/careers/career-asset-08.png';
import teamFace09 from '../../assets/careers/career-asset-11.png';
import teamFace10 from '../../assets/careers/career-asset-12.png';
import teamFace11 from '../../assets/careers/career-asset-13.png';
import teamFace12 from '../../assets/careers/career-asset-15.png';
import teamFace13 from '../../assets/careers/career-asset-17.png';
import teamFace14 from '../../assets/careers/career-asset-18.png';
import teamFace15 from '../../assets/careers/career-asset-19.png';
import teamFace16 from '../../assets/careers/career-asset-20.png';
import newsletterArt from '../../assets/careers/newsletter-art.png';
import { sendContactEmail } from '../../utils/emailjs';

const teamFaces = [
  teamFace01,
  teamFace02,
  teamFace03,
  teamFace04,
  teamFace05,
  teamFace06,
  teamFace07,
  teamFace08,
  teamFace09,
  teamFace10,
  teamFace11,
  teamFace12,
  teamFace13,
  teamFace14,
  teamFace15,
  teamFace16,
];

const teamRows = [
  {
    key: 'row1',
    left: [teamFaces[5]],
    right: [teamFaces[0], teamFaces[3], teamFaces[2], teamFaces[1], teamFaces[4]],
  },
  {
    key: 'row2',
    left: [teamFaces[15], teamFaces[10], teamFaces[11]],
    right: [teamFaces[12], teamFaces[14], teamFaces[13]],
  },
  {
    key: 'row3',
    left: [teamFaces[9]],
    right: [teamFaces[8], teamFaces[7], teamFaces[6], teamFaces[5]],
  },
];

const SMS_CONSENT_VERSION = 'KG-SMS-CONSENT-v1-2026-09-11';
const PROMO_CONSENT_VERSION = 'KG-SMS-PROMO-CONSENT-v1-2026-10-19';
const PROMO_CONSENT_DISCLOSURE = 'I agree to receive promotional text messages from Kothawala Group Inc about future job openings, hiring events, and recruitment opportunities at the mobile number provided. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for assistance. Consent is optional and is not a condition of employment. See our Privacy Policy and SMS Terms & Conditions.';

const Careers = () => {
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });
  const [careerForm, setCareerForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    smsConsent: false,
    promoConsent: false,
  });
  const [isCareerFormSent, setIsCareerFormSent] = useState(false);
  const openingsRef = useRef(null);

  const handleNewsletterChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Careers Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  const handleCareerFormChange = (event) => {
    const { name, value, type, checked } = event.target;
    setIsCareerFormSent(false);
    setCareerForm((current) => ({
      ...current,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleCareerFormSubmit = async (event) => {
    event.preventDefault();
    const submittedAt = new Date().toLocaleString();
    const consentDisclosure = 'I consent to receive text messages regarding my employment application, interview scheduling, onboarding, and related recruiting communications from Kothawala Group at the mobile number I provided. Consent is not a condition of employment. Message and data rates may apply. Message frequency varies. Reply HELP for assistance or STOP to opt out. Privacy Policy and SMS Terms & Conditions.';

    await sendContactEmail(
      {
        name: careerForm.name,
        email: careerForm.email,
        phone: careerForm.phone,
        message: careerForm.message,
        smsOptIn: careerForm.smsConsent ? 'Yes' : 'No',
        smsConsentStatus: careerForm.smsConsent ? 'Opted In' : 'Not Opted In',
        smsConsentTimestamp: careerForm.smsConsent ? submittedAt : 'Not provided',
        smsConsentVersion: SMS_CONSENT_VERSION,
        smsConsentDisclosure: consentDisclosure,
        promoSmsOptIn: careerForm.promoConsent ? 'Yes' : 'No',
        promoSmsConsentStatus: careerForm.promoConsent ? 'Opted In' : 'Not Opted In',
        promoSmsConsentTimestamp: careerForm.promoConsent ? submittedAt : 'Not provided',
        promoSmsConsentVersion: PROMO_CONSENT_VERSION,
        promoSmsConsentDisclosure: PROMO_CONSENT_DISCLOSURE,
      },
      'Careers Application',
    );

    setIsCareerFormSent(true);
    setCareerForm({
      name: '',
      email: '',
      phone: '',
      message: '',
      smsConsent: false,
      promoConsent: false,
    });
  };

  const handleApplyNowClick = () => {
    if (!openingsRef.current) {
      return;
    }

    const navbar = document.querySelector('.kw__navbar');
    const navbarOffset = navbar ? navbar.getBoundingClientRect().height : 0;
    const y = openingsRef.current.getBoundingClientRect().top + window.scrollY - navbarOffset - 24;

    window.scrollTo({
      top: Math.max(0, y),
      behavior: 'smooth',
    });

    window.history.replaceState(null, '', '#kw-careers-openings');
  };

  useEffect(() => {
    if (window.location.hash === '#kw-careers-openings') {
      requestAnimationFrame(() => {
        handleApplyNowClick();
      });
    }
  }, []);

  return (
    <div className="kw__careers-page">
      <section className="kw__careers-hero kw__careers-section">
        <h1 className="kw__careers-hero-title">
          Step Into Something Bigger at Kothawala,
          <br />
          Where Your Potential Has Room to Grow.
        </h1>
        <p className="kw__careers-hero-copy">
          At Kothawala Group, careers are not built by chance. They are shaped with intent. We don&apos;t just recruit talent; we develop people, grow
          leaders, and build workplaces where performance becomes progress. We offer roles that challenge you, accelerate your growth, and give you the
          opportunity to make a measurable impact.
        </p>
        <button type="button" className="kw__careers-hero-button" onClick={handleApplyNowClick}>
          <span>Apply Now</span>
          <img src={buttonArrow} alt="" />
        </button>
      </section>

      <section className="kw__careers-team">
        <div className="kw__careers-section kw__careers-team-inner">
          <div className="kw__careers-team-art">
            <div className="kw__careers-team-word kw__careers-team-word--join">Join</div>
            <div className="kw__careers-team-word kw__careers-team-word--the">The</div>
            <div className="kw__careers-team-word kw__careers-team-word--team">Team</div>
            {teamRows.map((row, rowIndex) => (
              <div key={row.key} className={`kw__careers-team-row kw__careers-team-row--${rowIndex + 1}`}>
                <div className="kw__careers-team-group kw__careers-team-group--left">
                  {row.left.map((src, index) => (
                    <img key={`${row.key}-left-${index}`} src={src} alt="Team member" className="kw__careers-team-face" />
                  ))}
                </div>
                <div className="kw__careers-team-group kw__careers-team-group--right">
                  {row.right.map((src, index) => (
                    <img key={`${row.key}-right-${index}`} src={src} alt="Team member" className="kw__careers-team-face" />
                  ))}
                </div>
              </div>
            ))}
          </div>

          <h2 className="kw__careers-team-title">Our People Are The Foundation Of Everything We Build.</h2>
          <p className="kw__careers-team-copy">
            At Kothawala Group, we assemble experienced individuals who plan ahead, operate with precision, and act with purpose. Whether you are a
            production head, operations lead, or an executive with years of experience, each person is a part of a work environment that thrives on
            discipline, creativity, and performance.
          </p>
          <p className="kw__careers-team-emphasis">We Don&apos;t Just Value Skills - We Value Mindsets!</p>
        </div>
      </section>

      <section id="kw-careers-openings" className="kw__careers-openings kw__careers-section" ref={openingsRef}>
        <p className="kw__careers-openings-word">Elevate.</p>
        <h2 className="kw__careers-openings-title">Grow Your Career With Us.</h2>
        <p className="kw__careers-openings-copy">
          Explore our current opportunities to step into a career defined by impact, scale, and measurable success.
        </p>

        <p className="kw__careers-openings-apply">
          Send your resume to <a href="mailto:admin@kothawalagroup.com">admin@kothawalagroup.com</a>.
        </p>

        <form className="kw__careers-openings-form" onSubmit={handleCareerFormSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={careerForm.name}
            onChange={handleCareerFormChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={careerForm.email}
            onChange={handleCareerFormChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={careerForm.phone}
            onChange={handleCareerFormChange}
          />
          <textarea
            name="message"
            placeholder="Message"
            value={careerForm.message}
            onChange={handleCareerFormChange}
            required
          />
          <label className="kw__careers-sms-consent" htmlFor="kw-careers-sms-consent">
            <input
              id="kw-careers-sms-consent"
              type="checkbox"
              name="smsConsent"
              checked={careerForm.smsConsent}
              onChange={handleCareerFormChange}
            />
            <span>
              I consent to receive text messages regarding my employment application, interview scheduling, onboarding, and related recruiting
              communications from Kothawala Group at the mobile number I provided. Consent is not a condition of employment. Message and data
              rates may apply. Message frequency varies. Reply HELP for assistance or STOP to opt out.{' '}
              <a href="/privacy#privacy-policy">Privacy Policy</a> &amp; <a href="/privacy#sms-terms">SMS Terms &amp; Conditions</a>.
            </span>
          </label>
          <label className="kw__careers-sms-consent" htmlFor="kw-careers-promo-consent">
            <input
              id="kw-careers-promo-consent"
              type="checkbox"
              name="promoConsent"
              checked={careerForm.promoConsent}
              onChange={handleCareerFormChange}
            />
            <span>
              I agree to receive promotional text messages from Kothawala Group Inc about future job openings, hiring events, and recruitment
              opportunities at the mobile number provided. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP
              for assistance. Consent is optional and is not a condition of employment. See our{' '}
              <a href="/privacy#privacy-policy">Privacy Policy</a> and <a href="/privacy#sms-terms">SMS Terms &amp; Conditions</a>.
            </span>
          </label>
          <button type="submit" className="kw__careers-openings-submit">
            <span className="kw__careers-openings-submit-text">Send</span>
            <span className="kw__careers-openings-submit-icon">
              <img src={buttonArrow} alt="" />
            </span>
          </button>
        </form>

        {isCareerFormSent && <p className="kw__careers-openings-success">Thank you, we will contact you shortly.</p>}
      </section>

      <section className="kw__careers-newsletter kw__careers-section" style={{ backgroundImage: `url(${newsletterArt})` }}>
        <div className="kw__careers-newsletter-copy">
          <p className="kw__careers-newsletter-label">Newsletter</p>
          <h2 className="kw__careers-newsletter-title">Never Miss An Update</h2>
          <p className="kw__careers-newsletter-text">
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to your
            inbox.
          </p>
        </div>

        <form className="kw__careers-newsletter-form" onSubmit={handleNewsletterSubmit}>
          <div className="kw__careers-newsletter-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleNewsletterChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleNewsletterChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleNewsletterChange} />
          <button type="submit" className="kw__careers-newsletter-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default Careers;
